(function() {
  if (window.__etGiftBarInit) return;
  window.__etGiftBarInit = true;

  var busy = false;
  var lastCartTotal = -1;

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getConfig() {
    var bar = document.getElementById('EtGiftBar');
    if (!bar) return null;
    return {
      bar: bar,
      threshold: parseInt(bar.getAttribute('data-threshold'), 10),
      variantId: parseInt(bar.getAttribute('data-variant-id'), 10)
    };
  }

  function getCartTotalWithoutGift(cart, variantId) {
    var total = cart.total_price;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) total -= cart.items[i].final_line_price;
    }
    return Math.max(0, total);
  }

  function findGiftItem(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return cart.items[i];
    }
    return null;
  }

  function updateBarDOM(bar, totalWithoutGift, threshold) {
    var reached = totalWithoutGift >= threshold;
    var remaining = Math.max(0, threshold - totalWithoutGift);
    var pct = Math.min(100, (totalWithoutGift / threshold) * 100);

    var fill = bar.querySelector('[data-fill]');
    if (fill) fill.style.width = pct + '%';

    var remainingEl = bar.querySelector('[data-remaining]');
    if (remainingEl) remainingEl.textContent = formatMoney(remaining);

    if (reached) {
      bar.classList.add('et-gift-bar--reached');
    } else {
      bar.classList.remove('et-gift-bar--reached');
    }
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('reload-side-cart'));
  }

  function pollCart() {
    if (busy) return;

    var cfg = getConfig();
    if (!cfg) return;

    busy = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var totalWithoutGift = getCartTotalWithoutGift(cart, cfg.variantId);

        updateBarDOM(cfg.bar, totalWithoutGift, cfg.threshold);

        if (totalWithoutGift === lastCartTotal) return;
        lastCartTotal = totalWithoutGift;

        var reached = totalWithoutGift >= cfg.threshold;
        var giftItem = findGiftItem(cart, cfg.variantId);

        if (reached && !giftItem) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1, properties: { '_free_gift': 'true' } }] })
          }).then(function() {
            lastCartTotal = -1;
            refreshCartDrawer();
          });
        } else if (!reached && giftItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: giftItem.key, quantity: 0 })
          }).then(function() {
            lastCartTotal = -1;
            refreshCartDrawer();
          });
        }
      })
      .catch(function() {})
      .then(function() { busy = false; });
  }

  setInterval(pollCart, 1000);
  pollCart();
})();
